<template>
  <q-page padding>
    <div class="row text-brand-5">
      <q-icon
        @click="voltar()"
        style="margin-top: 3px; cursor: pointer"
        size="sm"
        name="arrow_back_ios"
        class="cursor"
      />

      <span class="text-brand-5 text-weight-bold text-h6"
        >Detalhes Termos de Uso: {{ termoId }}</span
      >
    </div>
    <div
      class="row col-12 q-mt-lg q-gutter-sm text-brand-5 text-weight-bold text-body"
    >
      <div class="col-2">
        <div class="q-ml-sm">Título</div>
        <q-input
          outlined
          dense
          disable
          v-model="termosDetalhes.titulo"
          bg-color="brand-7"
        />
      </div>
      <div class="col-2">
        <div class="q-ml-sm">Status</div>
        <q-input
          outlined
          dense
          disable
          v-model="termosDetalhes.status"
          bg-color="brand-7"
        />
      </div>
      <div class="col-2">
        <div class="q-ml-sm">Emissor</div>
        <q-input
          outlined
          dense
          disable
          v-model="termosDetalhes.usuarioCriacao"
          bg-color="brand-7"
        />
      </div>
      <div class="col-2">
        <div class="q-ml-sm">Data de Criação</div>
        <q-input
          outlined
          dense
          disable
          v-model="dataCriacao"
          bg-color="brand-7"
        />
      </div>
    </div>
    <div class="text-brand-5 text-weight-bold q-mt-md">
      <div class="q-ml-sm">Descrição</div>
      <div
        style="height: 50vh; border: 1px solid; border-radius: 5px"
        class="scroll"
      >
        <p class="text-brand-5 text-weight-bold">
          {{ termosDetalhes.descricao }}
        </p>
      </div>
    </div>
  </q-page>
</template>

<script>
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted } from "vue";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const termoId = route.params.termoId;
    const termosDetalhes = ref([]);
    const dataCriacao = ref();

    const listarDetalhes = async () => {
      let resposta = await store.dispatch("office/detalharTermoDeUso", {
        termoDeUsoId: termoId,
      });
      termosDetalhes.value = resposta.data.resultado.dados;
      dataCriacao.value = resposta.data.resultado.dados.dataHoraCricao
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");
    };

    const voltar = () => {
      router.push({ name: "termosdeuso" });
    };

    onMounted(listarDetalhes);

    return {
      listarDetalhes,
      termosDetalhes,
      termoId,
      dataCriacao,
      voltar,
    };
  },
};
</script>
